(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .directive('tfcFilterPanel', tfcFilterPanel)
      .controller('FilterPanelCtrl', FilterPanelCtrl);

  function FilterPanelCtrl(){
    var vm = this;
    this.isCollapsed = false;

    vm.toggleDiv = function(){
      var display = this.isCollapsed ? 'block' : 'none';
      this.isCollapsed = !this.isCollapsed;
      angular.element(document.getElementsByClassName('box-data')).css({'display':display});
    };
  }

  function tfcFilterPanel($timeout){
    return {
      restrict: 'E',
      scope: {},
      templateUrl : 'Util/FilterPanel/FilterPanel.tmpl.html',
      transclude: true,
      bindToController : true,
      controller : 'FilterPanelCtrl as vm',
      link: function (scope, elem) {
        scope.isFilterPanelExist = true;
        $timeout(function(){
          scope.isFilterPanelExist = elem[0].querySelector('.filter') !== null;
        },0,false);
      }
    }
  }

})();